import { render, staticRenderFns } from "./ss-user-info-right.vue?vue&type=template&id=91212826&"
import script from "./ss-user-info-right.vue?vue&type=script&lang=js&"
export * from "./ss-user-info-right.vue?vue&type=script&lang=js&"
import style0 from "./ss-user-info-right.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports